/**
 * Initialize Microsoft Clarity tracking
 * This will only run in production environment
 */
export const initializeClarity = () => {
  const clarityId = process.env.REACT_APP_CLARITY_ID;
  const isProduction = process.env.REACT_APP_ENV === 'production';

  // Only initialize Clarity in production and if the ID is configured
  if (!isProduction || !clarityId) {
    if (process.env.REACT_APP_DEBUG === 'true') {
      console.log('Clarity tracking not initialized:', {
        isProduction,
        hasId: !!clarityId,
      });
    }
    return;
  }

  try {
    // Microsoft Clarity initialization script
    (function(c, l, a, r, i, t, y) {
      c[a] = c[a] || function() {
        (c[a].q = c[a].q || []).push(arguments);
      };
      t = l.createElement(r);
      t.async = 1;
      t.src = "https://www.clarity.ms/tag/" + i;
      y = l.getElementsByTagName(r)[0];
      y.parentNode.insertBefore(t, y);
    })(window, document, "clarity", "script", clarityId);

    if (process.env.REACT_APP_DEBUG === 'true') {
      console.log('Microsoft Clarity initialized with ID:', clarityId);
    }
  } catch (error) {
    console.error('Error initializing Microsoft Clarity:', error);
  }
};
